import {
  TOGGLE_DMX_UNIVERSE_STATUS,
  TOGGLE_DMX_UNIVERSE_STATUS_SUCCESSFUL,
  TOGGLE_DMX_UNIVERSE_STATUS_FAILED,
} from './actionTypes';

const initialState = {
  toggleDmxUniverseStatusError: null,
  messageDmxUniverse: null,
  loadingToggleDmxUniverseStatus: false,
};

const toggleUniverseStatus = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DMX_UNIVERSE_STATUS:
      state = { ...state, loadingToggleDmxUniverseStatus: true, toggleDmxUniverseStatusError: null };
      break;
    case TOGGLE_DMX_UNIVERSE_STATUS_SUCCESSFUL:
      state = {
        ...state,
        loadingToggleDmxUniverseStatus: false,
        messageDmxUniverse: action.payload,
        toggleDmxUniverseStatusError: null,
      };
      break;
    case TOGGLE_DMX_UNIVERSE_STATUS_FAILED:
      state = {
        ...state,
        messageDmxUniverse: null,
        loadingToggleDmxUniverseStatus: false,
        toggleDmxUniverseStatusError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default toggleUniverseStatus;
